import UserSmallHeader from 'components/Headers/UserSmallHeader';
import { useEffect, useState } from 'react';
import { FaCheckCircle, FaHistory, FaInfoCircle } from 'react-icons/fa';
import { Tooltip } from '@material-ui/core';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  InputGroup,
  Label,
  Row,
} from 'reactstrap';
import toast from 'react-hot-toast';
import api from 'services/api';
import { useQuery } from 'react-query';

import ModalLog from 'components/ModalLog';
import Perfil from 'models/Perfil';
import { ContainerButtons } from './styles';
import Parametros from '../../../models/Parametros';
import ProdutoCategoriaModel from '../../../models/ProdutoCategoria';
import InputMoeda from '../Proposta/components/Materiais/components/Precificacao/components/InputMoeda';
import InputPercentual from '../Proposta/components/Materiais/components/Precificacao/components/InputPercentual';
import InputNumber from '../Proposta/components/Materiais/components/Precificacao/components/InputNumber';

export default function TelaParametros(): JSX.Element {
  const [atualizando, setAtualizando] = useState(false);

  const [modalLogVisivel, setModalLogVisivel] = useState(false);
  const [valorDolar, setValorDolar] = useState(0);
  const [precificacaoPercentual1, setprecificacaoPercentual1] = useState(0);
  const [precificacaoPercentual2, setprecificacaoPercentual2] = useState(0);
  const [minutosCalculoLances, setMinutosCalculoLances] = useState(0);
  const [fatorToleranciaLancesManual, setFatorToleranciaLancesManual] =
    useState(0);
  const [fatorToleranciaPerdaCarga, setFatorToleranciaPerdaCarga] = useState(0);

  const [propostaJurosMensal, setPropostaJurosMensal] = useState(0);

  const [diasDefaultDataEmbarque, setDiasDefaultDataEmbarque] = useState(0);

  const [modalProp, setModalProp] = useState('valorDolar');
  const [categoriaProdutos, setCategoriaProdutos] = useState(
    [] as ProdutoCategoriaModel[],
  );
  const [categoriaFotovoltaicaId, setCategoriaFotovoltaicaId] = useState(0);
  const [validadeProposta, setValidadeProposta] = useState(0);
  const [raioValidacaoPivos, setRaioValidacaoPivos] = useState(0);
  const [diasCancelarProposta, setDiasCancelarProposta] = useState(0);
  const [
    notificacaoAssistTecnicaPerfilId,
    setNotificacaoAssistTecnicaPerfilId,
  ] = useState(0);
  const [notificacaoParcelasPerfilId, setNotificacaoParcelasPerfilId] =
    useState(0);
  const [bloquearAcessoConfigManutencao, setBloquearAcessoConfigManutencao] =
    useState(0);
  const [
    bloquearAcessoConcluidoEngenharia,
    setBloquearAcessoConcluidoEngenharia,
  ] = useState(0);
  const [perfis, setPerfis] = useState([] as Perfil[]);
  const [eventoGeracaoPedido, setEventoGeracaoPedido] = useState('');
  const [psTemplate, setPsTemplate] = useState('');

  async function listaProdutoCategoria() {
    const response = await api.get('/produto-categoria');
    setCategoriaProdutos(response.data);
  }

  async function listaPerfis() {
    const response = await api.get('/perfil');
    setPerfis(response.data);
  }

  const { data: queryParametros, isLoading } = useQuery(
    `parametros`,
    async () => {
      async function getData(): Promise<Parametros> {
        const response = await api.get('/parametros');
        return response.data;
      }

      const dataParametros = await getData();
      return dataParametros;
    },
  );

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    listaPerfis();
  }, []);

  useEffect(() => {
    if (queryParametros) {
      setValorDolar(queryParametros.valorDolar ?? 0);
      setprecificacaoPercentual1(queryParametros.precificacaoPercentual1 ?? 0);
      setprecificacaoPercentual2(queryParametros.precificacaoPercentual2 ?? 0);
      setCategoriaFotovoltaicaId(queryParametros.categoriaFotovoltaicaId ?? 0);
      setMinutosCalculoLances(queryParametros.minutosCalculoLances ?? 0);
      setFatorToleranciaLancesManual(
        queryParametros.fatorToleranciaLancesManual ?? 0,
      );
      setFatorToleranciaPerdaCarga(
        queryParametros.fatorToleranciaPerdaCarga ?? 0,
      );
      setPropostaJurosMensal(queryParametros.propostaJurosMensal ?? 0);
      setDiasDefaultDataEmbarque(queryParametros.diasDefaultDataEmbarque ?? 0);
      setValidadeProposta(queryParametros.validadeProposta ?? 0);
      setRaioValidacaoPivos(queryParametros.raioValidacaoPivos ?? 0);
      setDiasCancelarProposta(queryParametros.diasCancelarProposta ?? 0);

      setNotificacaoParcelasPerfilId(
        queryParametros.notificacaoParcelasPerfilId ?? 0,
      );

      setNotificacaoAssistTecnicaPerfilId(
        queryParametros.notificacaoAssistTecnicaPerfilId ?? 0,
      );
      setBloquearAcessoConfigManutencao(
        queryParametros.bloquearAcessoConfigManutencao ?? 0,
      );
      setBloquearAcessoConcluidoEngenharia(
        queryParametros.bloquearAcessoConcluidoEngenharia ?? 0,
      );
      setEventoGeracaoPedido(queryParametros.eventoGeracaoPedido ?? '');
      setPsTemplate(queryParametros.psTemplate ?? '');
    }
  }, [queryParametros]);

  useEffect(() => {
    listaProdutoCategoria();
  }, []);

  useEffect(() => {
    listaPerfis(); // Fetch profiles on component mount
  }, []);

  async function handleSalvarRegistro() {
    if (minutosCalculoLances < 2) {
      toast.error(
        `O valor para cálculo de lances não pode ser inferior à 2 minutos`,
      );
      return;
    }

    async function salvar() {
      const dataSend = {
        valorDolar,
        precificacaoPercentual1,
        precificacaoPercentual2,
        categoriaFotovoltaicaId,
        minutosCalculoLances,
        fatorToleranciaLancesManual,
        fatorToleranciaPerdaCarga,
        validadeProposta,
        propostaJurosMensal,
        diasDefaultDataEmbarque,
        raioValidacaoPivos,
        diasCancelarProposta,
        notificacaoParcelasPerfilId,
        notificacaoAssistTecnicaPerfilId,
        bloquearAcessoConfigManutencao,
        bloquearAcessoConcluidoEngenharia,
        eventoGeracaoPedido,
        psTemplate,
      };

      await api.put('/parametros', dataSend);
    }

    try {
      setAtualizando(true);

      toast.promise(salvar(), {
        loading: 'Aguarde...',
        success: <b>Tudo certo!</b>,
        error: <b>Algo de errado aconteceu.</b>,
      });
    } finally {
      setAtualizando(false);
    }
  }

  async function mostrarModalLog(chave: string) {
    setModalProp(chave);
    setModalLogVisivel(true);
  }

  return (
    <>
      <ModalLog
        nomeChave="parametros"
        valorChave={modalProp}
        titulo="Logs"
        modalState={modalLogVisivel}
        toggle={() => setModalLogVisivel(false)}
      />
      <UserSmallHeader />
      <Card>
        <CardHeader>
          <strong className="text-muted">Parâmetros</strong>
          <ContainerButtons>
            <Button
              className="btn btn-outline-primary mb-2"
              type="button"
              size="sm"
              disabled={atualizando}
              onClick={handleSalvarRegistro}
            >
              Salvar <FaCheckCircle />
            </Button>
          </ContainerButtons>
        </CardHeader>
        <CardBody>
          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputMoeda
                label="Valor do Dólar"
                value={valorDolar}
                onChange={setValorDolar}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('valorDolar')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>
          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputPercentual
                label="Imposto ICMS"
                value={precificacaoPercentual1}
                onChange={setprecificacaoPercentual1}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Imposto para composição do valor de custo nos resultados de uma proposta. Não trata-se do imposto efetivo da composição do valor de uma proposta, que é extraído do ERP.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('precificacaoPercentual1')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>
          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputPercentual
                label="Imposto PIS/Cofins"
                value={precificacaoPercentual2}
                onChange={setprecificacaoPercentual2}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Imposto para composição do valor de custo nos resultados de uma proposta. Não trata-se do imposto efetivo da composição do valor de uma proposta, que é extraído do ERP.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('precificacaoPercentual2')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>
          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputNumber
                label="Minutos Cálculo Lances"
                value={minutosCalculoLances}
                onChange={setMinutosCalculoLances}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica o tempo, em minutos, em que o cálculo de lances ficará aguardando antes de disparar o processo de cálculo assíncrono.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('minutosCalculoLances')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>
          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputNumber
                label="Fator Tolerância Lances Manual"
                value={fatorToleranciaLancesManual}
                onChange={setFatorToleranciaLancesManual}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica o fator de tolerância utilizada no cálculo de lances manual">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('fatorToleranciaLancesManual')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputPercentual
                label="Fator Tolerância Perda Carga"
                value={fatorToleranciaPerdaCarga}
                onChange={setFatorToleranciaPerdaCarga}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica o fator de tolerância para a perda de carga">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('fatorToleranciaPerdaCarga')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputNumber
                label="Validade da proposta (Em dias)"
                value={validadeProposta}
                onChange={setValidadeProposta}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica a quantidade de dias de vigência de uma proposta a partir da data de atualização.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('validadeProposta')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputPercentual
                label="Percentual Juros Mensal Analisador Proposta"
                value={propostaJurosMensal}
                onChange={setPropostaJurosMensal}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica o percentual de juros padrão para o cálculo do analisador.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('propostaJurosMensal')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2" hidden>
            <Col className="mb-2" xs="4" md="8">
              <InputNumber
                label="Dias Padrão para Embarque"
                value={diasDefaultDataEmbarque}
                onChange={setDiasDefaultDataEmbarque}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica a quantidade de dias default para o embarque, na aba do Analisador.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('diasDefaultDataEmbarque')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>
          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputNumber
                label="Raio validação dos pivôs"
                value={raioValidacaoPivos}
                onChange={setRaioValidacaoPivos}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica o raio para validação dos pivôs. Este parâmetro é opcional, para desativar a validação deve ser informado o valor zero.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('raioValidacaoPivos')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col className="mb-2" xs="4" md="8">
              <InputNumber
                label="Dias Cancelar Proposta"
                value={diasCancelarProposta}
                onChange={setDiasCancelarProposta}
              />
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Indica a quantidade de dias que uma proposta pode ficar inativa antes de ser cancelada. Este parâmetro é opcional, para desativar a validação deve ser informado o valor zero.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('diasCancelarProposta')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col style={{ margin: 0, padding: 5 }} md="5">
              <Label className="form-control-label float-right mt-3">
                Categoria UC questionário
              </Label>
            </Col>
            <Col md="3">
              <InputGroup className="input-group-alternative input-group">
                <Input
                  placeholder="Categoria UC questionário"
                  type="select"
                  value={categoriaFotovoltaicaId}
                  onChange={text =>
                    setCategoriaFotovoltaicaId(Number(text.target.value))
                  }
                >
                  <option value="">Categoria UC questionário...</option>
                  {categoriaProdutos.map(categoria => (
                    <option value={categoria.id}>{categoria.descricao}</option>
                  ))}
                </Input>
              </InputGroup>
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Define o uso da UC (unidade consumidora) no questionário para uma categoria de produtos, apresentando a possibilidade de cadastrar UCs e manter seus dados em cálculo específico para a geração de usinas fotovoltaicas.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('categoriaFotovoltaicaId')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col style={{ margin: 0, padding: 5 }} md="5">
              <Label className="form-control-label float-right mt-3">
                Perfil Notificar Solicitações Parcelas de Proposta
              </Label>
            </Col>
            <Col md="3">
              <InputGroup className="input-group-alternative input-group">
                <Input
                  placeholder="Selecione um perfil..."
                  type="select"
                  value={notificacaoParcelasPerfilId}
                  onChange={text =>
                    setNotificacaoParcelasPerfilId(Number(text.target.value))
                  }
                >
                  <option value="">Selecione...</option>
                  {perfis.map(perfil => (
                    <option key={perfil.id} value={perfil.id}>
                      {perfil.nome}
                    </option>
                  ))}
                </Input>
              </InputGroup>
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Define o perfil que receberá notificação de solicitações de alteração nas parcelas de proposta. Este parâmetro é opcional, para desativar a notificação deve informar o valor Selecione...">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('notificacaoParcelasPerfilId')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col style={{ margin: 0, padding: 5 }} md="5">
              <Label className="form-control-label float-right mt-3">
                Perfil Notificar Diferença % Assistência Técnica
              </Label>
            </Col>
            <Col md="3">
              <InputGroup className="input-group-alternative input-group">
                <Input
                  placeholder="Selecione um perfil..."
                  type="select"
                  value={notificacaoAssistTecnicaPerfilId}
                  onChange={text =>
                    setNotificacaoAssistTecnicaPerfilId(
                      Number(text.target.value),
                    )
                  }
                >
                  <option value="">
                    Perfil Notificar Diferença % Assistência Técnica
                  </option>
                  {perfis.map(perfil => (
                    <option key={perfil.id} value={perfil.id}>
                      {perfil.nome}
                    </option>
                  ))}
                </Input>
              </InputGroup>
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Define o perfil que receberá notificação de proposta com porcentagem de assistência técnica diferente da porcentagem cadastrada no usuário da mesma. Este parâmetro é opcional, para desativar a notificação deve informar o valor Perfil Notificar Diferença % Assistência Técnica.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() =>
                    mostrarModalLog('notificacaoAssistTecnicaPerfilId')
                  }
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col style={{ margin: 0, padding: 5 }} md="5">
              <Label className="form-control-label float-right mt-3">
                Bloquear para manutenção
              </Label>
            </Col>
            <Col md="3">
              <InputGroup className="input-group-alternative input-group">
                <Input
                  placeholder="Selecione um perfil..."
                  type="select"
                  value={bloquearAcessoConfigManutencao}
                  onChange={text =>
                    setBloquearAcessoConfigManutencao(Number(text.target.value))
                  }
                >
                  <option value="">Selecione...</option>
                  {perfis.map(perfil => (
                    <option key={perfil.id} value={perfil.id}>
                      {perfil.nome}
                    </option>
                  ))}
                </Input>
              </InputGroup>
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Define o perfil que irá ter acesso a uma proposta que foi bloqueada">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() =>
                    mostrarModalLog('bloquearAcessoConfigManutencao')
                  }
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col style={{ margin: 0, padding: 5 }} md="5">
              <Label className="form-control-label float-right mt-3">
                Concluído pela Engenharia
              </Label>
            </Col>
            <Col md="3">
              <InputGroup className="input-group-alternative input-group">
                <Input
                  placeholder="Selecione um perfil..."
                  type="select"
                  value={bloquearAcessoConcluidoEngenharia}
                  onChange={text =>
                    setBloquearAcessoConcluidoEngenharia(
                      Number(text.target.value),
                    )
                  }
                >
                  <option value="">Selecione...</option>
                  {perfis.map(perfil => (
                    <option key={perfil.id} value={perfil.id}>
                      {perfil.nome}
                    </option>
                  ))}
                </Input>
              </InputGroup>
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Define o perfil que irá ter acesso para alterar estado 'Concluído pela Engenharia' da configuração">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() =>
                    mostrarModalLog('bloquearAcessoConcluidoEngenharia')
                  }
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Row className="px-2">
            <Col style={{ margin: 0, padding: 5 }} md="5">
              <Label className="form-control-label float-right mt-3">
                Evento Geração Pedido
              </Label>
            </Col>
            <Col md="3">
              <InputGroup className="input-group-alternative input-group">
                <Input
                  placeholder="Digite o evento de geração de pedido..."
                  type="text"
                  value={eventoGeracaoPedido}
                  onChange={text => setEventoGeracaoPedido(text.target.value)}
                />
              </InputGroup>
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Define o evento utilizado para geração de pedidos.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('eventoGeracaoPedido')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>
          <Row className="px-2">
            <Col style={{ margin: 0, padding: 5 }} md="5">
              <Label className="form-control-label float-right mt-3">
                Template PS
              </Label>
            </Col>
            <Col md="3">
              <InputGroup className="input-group-alternative input-group">
                <Input
                  placeholder="Digite o template utilizado para gerar PS..."
                  type="text"
                  value={psTemplate}
                  onChange={text => setPsTemplate(text.target.value)}
                />
              </InputGroup>
            </Col>
            <Col className="mb-2" xs="2" md="4">
              <Tooltip title="Define o template que será utilizado para gearar o PS.">
                <Button
                  size="sm"
                  color="info"
                  outline
                  style={{ marginTop: '10px' }}
                >
                  <FaInfoCircle />
                </Button>
              </Tooltip>
              <Tooltip title="Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  style={{ marginTop: '10px' }}
                  onClick={() => mostrarModalLog('psTemplate')}
                >
                  <FaHistory />
                </Button>
              </Tooltip>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
}
